import { IFieldNames as I, IFieldSpec, IReasonOption } from "./types";

/** Reason dropdown options — first (empty) option is the default placeholder. */
export const reasonOptions: IReasonOption[] = [
  { id: "select-a-reason", value: "", label: "Select a reason" },
  { id: "car-repair", value: "Car Repair", label: "Car Repair" },
  { id: "home-repair", value: "Home Repair", label: "Home Repair" },
  { id: "appliance-repair", value: "Appliance Repair", label: "Appliance Repair" },
  { id: "medical-expenses", value: "Medical Expenses", label: "Medical Expenses" },
  { id: "make-other-payments", value: "Make other payments", label: "Make other payments" },
  { id: "pay-overdrafts", value: "Pay overdrafts", label: "Pay overdrafts" },
  { id: "emergency-expenses", value: "Emergency expenses", label: "Emergency expenses" },
  { id: "other", value: "Other", label: "Other" },
];

// Row 1: loan amount + reason, rendered as one joined control (like PayPlan/FTS).
export const primaryFields: IFieldSpec[] = [
  { name: I.requestedLoan, kind: "amount", label: "Loan Amount" },
  { name: I.reason, kind: "select", label: "Reason", options: reasonOptions },
];

// Rows 2-3: SSN + Email, then Phone — separated boxes.
export const personalFields: IFieldSpec[] = [
  { name: I.ssn, kind: "ssn", label: "SSN" },
  { name: I.email, kind: "text", label: "Email" },
  { name: I.phoneNumber, kind: "phone", label: "Phone Number" },
];

/** Test-only field, rendered only when localStorage "showMock" is set. */
export const mockField: IFieldSpec = {
  name: I.mockData,
  kind: "textarea",
  label: "Mock JSON data",
};

export const showMock = (): boolean =>
  typeof window !== "undefined" && localStorage.getItem("showMock") != null;

export const initForm = () => ({
  [I.requestedLoan]: { value: "", message: "", required: true },
  [I.reason]: { value: "", message: "", required: true },
  [I.ssn]: { value: "", message: "", required: true },
  [I.email]: { value: "", message: "", required: true },
  [I.phoneNumber]: { value: "", message: "", required: true },
  [I.mockData]: { value: "", message: "", required: false },
});
